import React from "react";
import DatePicker from "react-datepicker";

const GroupDate = (props) => {
  const {
    label = "",
    name = "",
    divClass = "input-group",
    labelClass = "",
    errorMsg,
    children,
    ...extra
  } = props;
  return (
    <li>
      <label className={labelClass}>{label}</label>
      <div className={divClass}>
        <DatePicker name={name} id={props?.id ?? name} {...extra} />
        {children ?? ""}
        {errorMsg ?? ""}
      </div>
    </li>
  );
};

export default GroupDate;
